<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">
    <vx-tour :callbacks="tour_callback" :steps="tour_steps" v-if='isTourStarted' />
    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

    <template>
      <the-navbar-vertical-home
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

      <div class="content-wrapper">
        <!-- <h2>{{ $t('COPYRIGHT') }}</h2> -->
        <div class="router-view">
          <div class="router-content">

              <div class="content-area__content">
                <!-- <span data-tour='2' ref='tour-step-2' style='display: none;'>&nbsp;</span> -->
              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer></the-footer>
    </div>
  </div>
</template>
<style scoped>
  #content-area.content-area-reduced {
    margin-left: 0px !important;
  }
  .navbar-floating .router-content {
    margin-top: 0px !important; 
  }
</style>

<script>
import BackToTop           from 'vue-backtotop'
import HNavMenu            from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
import navMenuItems        from "@/layouts/components/vertical-nav-menu/navMenuItems.js"
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVerticalHome  from '@/layouts/components/navbar/TheNavbarVerticalHome.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import { mapGetters }      from 'vuex'
const VxTour = () => import('@/components/VxTour.vue')

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVerticalHome,
    VNavMenu,
    VxTour
  },
  data() {
    return {
      tour_steps: [],
      tour_callback: {
        onNextStep: this.tourNextStep,
        onFinish: this.tourFinish,
        onStop: this.tourFinish
      },
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems      : navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle
    }
  },
  watch: {
    isTourStarted: function(is) {
      if(is)
        this.mapTourSteps();
    },
    "$route"() {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
      this.updateNavbarColor(color)
    },
    "$store.state.app.mainLayoutType"(val) {
      this.setNavMenuVisibility(val)
    },

  },
  created() {
    const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.app.mainLayoutType)
    this.isTourStarted && this.mapTourSteps();
  },
	async mounted() {
		window.Echo.private('changeUserCurrentUrl'+this.$store.getters.currentUser.id)
    .listen('ChangeUserUrlEvent', response => {
      if(response.new_page!=this.$route.path){
        let l = this.$router.resolve({path: response.new_page});
        if( l.resolved.matched.length > 0)
          this.$router.push({ path: response.new_page });
      }
    });
	},
  computed: {
    ...mapGetters([
			"isTourStarted"
		]),
    bodyOverlay() { return this.$store.state.app.bodyOverlay },
    contentAreaClass() {
      if(this.mainLayoutType === "vertical") {
        if      (this.verticalNavMenuWidth == "default") return "content-area-reduced"
        else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
        else return "content-area-full"
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full"
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      }
    },
    isAppPage() {
      return this.$route.meta.no_scroll
    },
    isThemeDark()     { return this.$store.state.app.theme == 'dark' },
    layoutTypeClass() { return `main-${this.mainLayoutType}` },
    mainLayoutType()  { return this.$store.state.app.mainLayoutType  },
    navbarClasses()   {
      return {
        'navbar-hidden'   : this.navbarType == 'hidden',
        'navbar-sticky'   : this.navbarType == 'sticky',
        'navbar-static'   : this.navbarType == 'static',
        'navbar-floating' : this.navbarType == 'floating',
      }
    },
    verticalNavMenuWidth() { return this.$store.state.app.verticalNavMenuWidth },
    windowWidth()          { return this.$store.state.app.windowWidth }
  },
  methods: {
    tourFinish() { 
      this.$store.dispatch('setIsTourStarted', false);
      console.log('tourFinish');
    },
    tourNextStep(step) {
      const curr = step+1;
      this.$store.commit('UDATE_CURRENT_TOUR_STEP', curr);
    },
    mapTourSteps() {
      const total_steps = 9; 
      this.$store.commit('SET_TOUR_RESOLVER', total_steps);
      const steps = [];
      // i==3?'head':
      for(let i=0; i<total_steps; i++) {
        steps.push({
          target: '[data-tour="step-'+i+'"]',
          content: "TOUR.USER.STEP-"+i+".CONTENT",
          header: {
            title: "TOUR.USER.STEP-"+i+".TITLE"
          },
          before: type => {``
            this.$store.commit('UDATE_UPCOMING_TOUR_STEP', type);

            // if(i==2) 
            //   this.$refs['tour-step-2'].style.display = null;
            // else
            //   this.$refs['tour-step-2'].style.display = 'none';
            
            return this.$store.state.tour.promises[i]
          }
          
        })
      }
      
      this.tour_steps = steps;
    },
    changeRouteTitle(title) {
      this.routeTitle = title
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val == "#fff") this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    setNavMenuVisibility(layoutType) {
      if((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      }
      else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    }
  }
}

</script>

